import { Component, Input, ViewChild, ViewContainerRef } from '@angular/core';

@Component({
  moduleId: module.id,
  selector: 'icon-deposits',
  template: `
    <ng-template #template>
      <svg
        width="20"
        height="20"
        viewBox="0 0 442 442"
        fill="currentColor"
        version="1.1"
        id="Capa_1"
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        xml:space="preserve"
        class="ng-star-inserted"
      >
        <g>
          <path
            d="M432,0H10C4.477,0,0,4.478,0,10v422c0,5.522,4.477,10,10,10h422c5.523,0,10-4.478,10-10V10C442,4.478,437.523,0,432,0z M422,422H20V20h402V422z"
          ></path>
          <path
            d="M273.901,148.188c-0.202-0.147-0.411-0.275-0.62-0.404C258.534,137.224,240.481,131,221,131s-37.534,6.224-52.281,16.784 c-0.209,0.129-0.418,0.258-0.62,0.404c-0.22,0.16-0.424,0.332-0.627,0.506C145.359,165.108,131,191.408,131,221 c0,49.626,40.374,90,90,90s90-40.374,90-90c0-29.592-14.359-55.892-36.472-72.306C274.325,148.521,274.121,148.348,273.901,148.188 z M221,251c-16.542,0-30-13.458-30-30s13.458-30,30-30s30,13.458,30,30S237.542,251,221,251z M253.618,159.092l-11.923,16.411 C235.384,172.62,228.38,171,221,171s-14.384,1.62-20.695,4.502l-11.923-16.411C198.129,153.935,209.226,151,221,151 S243.871,153.935,253.618,159.092z M172.216,170.868l11.914,16.399C175.981,196.166,171,208.011,171,221 c0,1.903,0.117,3.777,0.325,5.625l-19.293,6.269C151.366,229.026,151,225.056,151,221C151,201.359,159.143,183.593,172.216,170.868 z M158.218,251.914l19.303-6.272c7.024,12.344,19.14,21.429,33.479,24.352v20.281C187.799,286.94,168.243,272.191,158.218,251.914z M231,290.274v-20.281c14.339-2.923,26.456-12.008,33.479-24.352l19.303,6.272C273.757,272.191,254.201,286.94,231,290.274z M291,221c0,4.056-0.366,8.026-1.032,11.895l-19.293-6.269c0.208-1.848,0.325-3.723,0.325-5.625 c0-12.989-4.981-24.834-13.13-33.733l11.914-16.399C282.857,183.593,291,201.359,291,221z"
          ></path>
          <path
            d="M50,349.997V382c0,5.522,4.477,10,10,10h322c5.523,0,10-4.478,10-10V154.111c0-5.522-4.477-10-10-10s-10,4.478-10,10V372 H70v-22.003c9.387-3.926,16-13.202,16-23.997v-50c0-10.795-6.613-20.071-16-23.997v-62.005c9.387-3.926,16-13.203,16-23.997v-50 c0-10.795-6.613-20.071-16-23.997V70h302v50c0,5.522,4.477,10,10,10s10-4.478,10-10V60c0-5.522-4.477-10-10-10H60 c-5.523,0-10,4.478-10,10v32.003C40.613,95.929,34,105.205,34,116v50c0,10.795,6.613,20.071,16,23.997v62.005 c-9.387,3.926-16,13.203-16,23.997v50C34,336.795,40.613,346.071,50,349.997z M66,276v50c0,3.309-2.691,6-6,6s-6-2.691-6-6v-50 c0-3.309,2.691-6,6-6S66,272.691,66,276z M54,166v-50c0-3.309,2.691-6,6-6s6,2.691,6,6v50c0,3.309-2.691,6-6,6S54,169.309,54,166z"
          ></path>
        </g>
      </svg>
    </ng-template>
  `,
})
export class IconDepositsComponent {
  @Input() class: any = '';
  @ViewChild('template', { static: true }) template: any;

  constructor(private viewContainerRef: ViewContainerRef) {}

  ngOnInit() {
    this.viewContainerRef.createEmbeddedView(this.template);
    this.viewContainerRef.element.nativeElement.remove();
  }
}
